import { UILineItemWithEditionPricing } from './sales-order-confirmation/sales-order-confirmation.service';

export type BillingLineItemSummary = {
  [key: string]: {
    sku: string;
    amount: number;
  };
};

export function convertLineItemsToBillingSummary(lineItems: UILineItemWithEditionPricing[]): BillingLineItemSummary {
  return lineItems.reduce((acc, li) => {
    if (li.lineItem?.currentRevenue?.revenueComponents) {
      li.lineItem.currentRevenue.revenueComponents.forEach((rev) => {
        if (!acc[li.billingId]) {
          acc[li.billingId] = { sku: li.billingId, amount: 0 };
        }
        acc[li.billingId].amount += rev.value;
      });
    }
    return acc;
  }, {});
}
